/**
 * Cognito feature-flag config for the Company app.
 *
 * src/cognito/oidc.ts. This file only reads env vars and exports the
 * useCognitoAuth flag consumed by main.ts, auth.ts and frontegg-shim.ts.
 */

/** True when the Cognito feature flag is enabled */
export const useCognitoAuth = process.env.VUE_APP_USE_COGNITO_AUTH === "true";
